import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Landing from "@/pages/Landing";
import Raffles from "@/pages/Raffles";
import RaffleDetail from "@/pages/RaffleDetail";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Winners from "@/pages/Winners";
import HowItWorks from "@/pages/HowItWorks";
import Support from "@/pages/Support";
import Affiliate from "@/pages/Affiliate";

function AppRouter() {
  const location = useLocation();

  // Capture ?ref=CODE from any page for 30 days
  React.useEffect(() => {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("ref");
    if (ref) {
      localStorage.setItem("rifa_ref", ref.toUpperCase());
      localStorage.setItem("rifa_ref_ts", String(Date.now()));
    }
    // Cleanup old refs > 30 days
    const ts = parseInt(localStorage.getItem("rifa_ref_ts") || "0");
    if (ts && Date.now() - ts > 30 * 24 * 3600 * 1000) {
      localStorage.removeItem("rifa_ref");
      localStorage.removeItem("rifa_ref_ts");
    }
  }, []);

  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/rifas" element={<Raffles />} />
          <Route path="/rifa/:id" element={<RaffleDetail />} />
          <Route path="/login" element={<AuthPage initialTab="login" />} />
          <Route path="/register" element={<AuthPage initialTab="register" />} />
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/ganhadores" element={<Winners />} />
          <Route path="/como-funciona" element={<HowItWorks />} />
          <Route path="/suporte" element={<Support />} />
          <Route path="/afiliados" element={<Affiliate />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
